import FileUpload from '~/scripts/services/model/file-upload';
/**
 *
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {File} file
 * @param {import('@knitiv/api-client-javascript').KNode} isa
 * @returns {Promise<FileUpload>}
 */
export const fromBlobToFileUpload = async ($injector, file, isa) => {
	const upload = new FileUpload($injector, file, file.name);
	upload.isa = isa;
	await upload.upload();
	await upload.prepareFinish();
	return upload;
};
